/* Celebra — bouton « Télécharger le fichier STL ».
 *
 * Sur les variantes qui ont un fichier STL, le bouton d'ajout au panier est
 * remplacé par un bouton de téléchargement et le sélecteur de quantité est
 * masqué. Fonctionne sur la fiche produit ET dans la fenêtre d'aperçu, qui
 * est une copie du HTML de la fiche : chaque formulaire est traité
 * séparément, avec ses propres données.
 *
 * Les données (variante → fichier) sont lues dans un bloc JSON présent à
 * côté du formulaire — un script cloné ne s'exécutant pas, on ne peut pas
 * les recevoir autrement.
 */
(function () {
  var LABEL = 'Télécharger le fichier STL';
  var LABEL_COURT = 'Télécharger';
  var busy = false, pending = false;
  var micro = window.queueMicrotask ? window.queueMicrotask.bind(window) : function (fn) { setTimeout(fn, 0); };

  (function styles() {
    if (document.getElementById('celebra-stl-styles')) return;
    var st = document.createElement('style');
    st.id = 'celebra-stl-styles';
    st.textContent = '[data-stl-hidden]{display:none !important}.stl-dl-btn[hidden]{display:none !important}';
    (document.head || document.documentElement).appendChild(st);
  })();

  /* Le conteneur qui englobe un formulaire : la fiche produit, ou la copie
     affichée dans la fenêtre d'aperçu. */
  function portee(form) {
    return form.closest('[data-product-grid-content]') || document;
  }

  function donnees(form) {
    var zone = portee(form);
    var bloc = zone.querySelector ? zone.querySelector('.stl-files-data') : null;
    if (!bloc) return null;
    if (bloc.__stlParsed) return bloc.__stlParsed;
    try { bloc.__stlParsed = JSON.parse(bloc.textContent || '[]'); } catch (e) { bloc.__stlParsed = []; }
    return bloc.__stlParsed;
  }

  /* Variante choisie : on lit les boutons cochés dans CE conteneur, pas dans
     toute la page — sinon la fiche et l'aperçu se marchent dessus. */
  function varianteCourante(form, variants) {
    var zone = portee(form);
    var choisis = {};
    var radios = zone.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) choisis[radios[i].value] = 1;
    var selects = zone.querySelectorAll('select[name]');
    for (var j = 0; j < selects.length; j++) choisis[selects[j].value] = 1;

    if (radios.length || selects.length) {
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k], ok = true;
        for (var n = 0; n < v.o.length; n++) if (!choisis[v.o[n]]) { ok = false; break; }
        if (ok) return v;
      }
    }
    var champ = form.querySelector('[name="id"]');
    var id = champ && champ.value ? String(champ.value).trim() : null;
    for (var m = 0; m < variants.length; m++) if (variants[m].id === id) return variants[m];
    return null;
  }

  function blocQuantite(form) {
    var q = form.querySelector('[name="quantity"]');
    if (!q) return null;
    var n = q.parentElement, best = q.parentElement;
    for (var k = 0; k < 4 && n && n !== form; k++) {
      var sig = (n.getAttribute('class') || '') + ' ' + n.tagName.toLowerCase();
      if (/quantity|qty/i.test(sig)) best = n;
      n = n.parentElement;
    }
    return best;
  }

  function bouton(form, submit) {
    var b = form.__stlBtn;
    if (!b || !document.body.contains(b)) {
      b = document.createElement('button');
      b.type = 'button';
      b.className = 'stl-dl-btn';
      b.hidden = true;
      b.textContent = LABEL;
      submit.insertAdjacentElement('afterend', b);
      form.__stlBtn = b;
    }
    return b;
  }

  function traiter(form, aGarder) {
    var submit = form.querySelector('[type="submit"]');
    var variants = donnees(form);
    if (!submit || !variants) return;

    var v = varianteCourante(form, variants);
    var url = v && v.f;

    var btn = bouton(form, submit);
    if (!url) {
      if (!btn.hidden) btn.hidden = true;
      return;
    }

    if (btn.className !== submit.className + ' stl-dl-btn') btn.className = submit.className + ' stl-dl-btn';
    if (btn.previousElementSibling !== submit) submit.insertAdjacentElement('afterend', btn);
    if (btn.getAttribute('data-stl-url') !== url) btn.setAttribute('data-stl-url', url);
    if (btn.textContent !== LABEL) btn.textContent = LABEL;
    if (btn.hidden) btn.hidden = false;

    aGarder.push(submit);
    var q = blocQuantite(form);
    if (q && !q.contains(submit)) aGarder.push(q);
  }

  /* Formulaire de la fiche produit elle-meme : ni celui de la fenetre
     d'apercu, ni un eventuel formulaire dans un <dialog>. */
  function formulairePrincipal() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest('[data-product-grid-content]') || f.closest('dialog') || f.closest('sticky-add-to-cart')) continue;
      return f;
    }
    return null;
  }

  /* Barre « ajouter au panier » qui apparait en bas quand on fait defiler la
   * fiche. Son bouton clique en douce sur le bouton principal : meme masque,
   * celui-ci ajoutait donc le STL gratuit au panier. Sur une variante STL, on
   * masque ce bouton et on affiche a la place un bouton de telechargement. */
  function barreCollante(aGarder) {
    var barres = document.querySelectorAll('sticky-add-to-cart');
    if (!barres.length) return;

    var form = formulairePrincipal();
    var principal = form && form.__stlBtn;
    var url = principal && !principal.hidden ? principal.getAttribute('data-stl-url') : null;

    for (var i = 0; i < barres.length; i++) {
      var barre = barres[i];
      var origine = barre.querySelector('.sticky-add-to-cart__button:not(.stl-dl-btn)');
      if (!origine) continue;

      var b = barre.__stlBtn;
      if (!b || !barre.contains(b)) {
        b = document.createElement('button');
        b.type = 'button';
        b.hidden = true;
        b.textContent = LABEL_COURT;
        origine.insertAdjacentElement('afterend', b);
        barre.__stlBtn = b;
      }

      if (!url) {
        if (!b.hidden) b.hidden = true;
        continue;
      }

      var classes = origine.className + ' stl-dl-btn';
      if (b.className !== classes) b.className = classes;
      if (b.previousElementSibling !== origine) origine.insertAdjacentElement('afterend', b);
      if (b.getAttribute('data-stl-url') !== url) b.setAttribute('data-stl-url', url);
      if (b.textContent !== LABEL_COURT) b.textContent = LABEL_COURT;
      if (b.hidden) b.hidden = false;
      aGarder.push(origine);
    }
  }

  function appliquer() {
    var aGarder = [];
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) traiter(forms[i], aGarder);
    barreCollante(aGarder);

    // nettoyage global : rien ne peut rester masqué par erreur
    var masques = document.querySelectorAll('[data-stl-hidden]');
    for (var j = 0; j < masques.length; j++) {
      if (aGarder.indexOf(masques[j]) === -1) masques[j].removeAttribute('data-stl-hidden');
    }
    for (var k = 0; k < aGarder.length; k++) {
      if (!aGarder[k].hasAttribute('data-stl-hidden')) aGarder[k].setAttribute('data-stl-hidden', '');
    }
  }

  function refresh() {
    if (busy) { pending = true; return; }
    busy = true;
    try { appliquer(); } catch (e) {}
    micro(function () {
      busy = false;
      if (pending) { pending = false; refresh(); }
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.stl-dl-btn') : null;
    if (t) {
      e.preventDefault();
      var u = t.getAttribute('data-stl-url');
      if (u) window.location.href = u;
      return;
    }
    refresh();
  });
  /* Garde-fou : un formulaire dont la variante est un STL ne doit jamais
   * partir vers le panier, quel que soit le bouton qui le declenche (barre
   * collante, touche Entree...). Pose sur window en capture pour passer
   * avant les ecouteurs du theme, poses sur document. */
  function estSTL(form) {
    var b = form && form.__stlBtn;
    return !!(b && !b.hidden && b.getAttribute('data-stl-url'));
  }

  window.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || !estSTL(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    },
    true
  );

  window.addEventListener(
    'click',
    function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-stl-hidden]') : null;
      if (!t || !t.matches('[type="submit"], [ref="addToCartButton"]')) return;
      if (!estSTL(t.form || t.closest('form'))) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener('change', refresh);
  window.addEventListener('popstate', refresh);

  function demarrer() {
    refresh();
    new MutationObserver(refresh).observe(document.documentElement, { childList: true, subtree: true });
    setInterval(refresh, 400);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
